const CONFIRMATION_DESCRIPTION_TYPES = Object.freeze({
    INFO: 'INFO',
    WARN: 'WARN',
  });
  
  export default CONFIRMATION_DESCRIPTION_TYPES;